import { useMemo } from 'react';
import landscapeSkyEffects from './landscapeSkyEffects.json';
import createSkyAnimation from './createSkyAnimation';
import Sky from '../../common/Sky';

export default function LandscapeSkyContainer() {
  const animation = useMemo(createSkyAnimation, []);

  return (
    <Sky
      beaker="chapter1"
      animation={ animation }
      effects={ landscapeSkyEffects }
    />
  );
};